   document.addEventListener('DOMContentLoaded', () => {
            const changeDate = (dateElement) => {
                const dateText = dateElement.textContent.trim();
                const [day, month, year] = dateText.split('.').map(Number);
                const originalDate = new Date(year, month - 1, day);
                const realDate = new Date();
                const daysDifference = Math.floor(Math.random() * 6); 
                realDate.setDate(realDate.getDate() - daysDifference);

                const newDay = String(realDate.getDate()).padStart(2, '0');
                const newMonth = String(realDate.getMonth() + 1).padStart(2, '0');
                const newYear = realDate.getFullYear();

                dateElement.textContent = `${newDay}.${newMonth}.${newYear}`;
            };

            const dateElements = document.querySelectorAll('[data-section-id="template--22591925092655__testimonials_custom_4HGHhD"] .date span');
            dateElements.forEach(changeDate);
        });



// Faq color tab

 document.addEventListener('DOMContentLoaded', () => {
      const buttons = document.querySelectorAll('.card__header.tab__header');

      buttons.forEach((button) => {
        const observer = new MutationObserver((mutationsList) => {
          mutationsList.forEach((mutation) => {
            if (mutation.type === 'attributes' && mutation.attributeName === 'class') {
              const spanElement = button.querySelector('.tab__header-title');
              if (button.classList.contains('active')) {
                spanElement.classList.add('faq-color');
              } else {
                spanElement.classList.remove('faq-color');
              }
            }
          });
        });

        observer.observe(button, { attributes: true });

        const spanElement = button.querySelector('.tab__header-title');
        if (button.classList.contains('active')) {
          spanElement.classList.add('faq-color');
        }
      });
    });

//  Shorten accordion FAQ
document.addEventListener('DOMContentLoaded', function () {
  const faqTabs = document.querySelectorAll('.js-faq-tab');
  const showAllButton = document.createElement('button');
  showAllButton.textContent = 'Show All';
  showAllButton.classList.add('show-all-button');

  const collapseAllButton = document.createElement('button');
  collapseAllButton.textContent = 'Minimize All';
  collapseAllButton.classList.add('collapse-all-button');

  let showAll = false;

  function toggleTabs() {
    faqTabs.forEach((tab, index) => {
      if (!showAll && index >= 7) {
        tab.style.display = 'none';
      } else {
        tab.style.display = 'block';
      }
    });

    showAllButton.style.display = showAll || faqTabs.length <= 7 ? 'none' : 'block';
    collapseAllButton.style.display = showAll ? 'block' : 'none';
  }

  const cardGroup = document.querySelector('.card-group');
  cardGroup.appendChild(showAllButton);
  cardGroup.appendChild(collapseAllButton);

  toggleTabs();

  showAllButton.addEventListener('click', function () {
    showAll = true;
    toggleTabs();
  });

  collapseAllButton.addEventListener('click', function () {
    showAll = false;
    toggleTabs();

    cardGroup.scrollIntoView({ behavior: 'smooth' });
  });
});

// Adding a tab container class
document.addEventListener('DOMContentLoaded', function() {
    const easytabsContents = document.querySelector('.easytabs-contents');
    if (easytabsContents) {
        easytabsContents.classList.add('container');
    }
});

// Zoom in on Table 1
document.addEventListener('DOMContentLoaded', function() {
    const image = document.querySelector('#expandable-image');

    image.addEventListener('click', function() {
        if (window.innerWidth <= 430) { 
            this.classList.toggle('fullscreen');
        }
    });
});

// Zoom in on Table 2
document.addEventListener('DOMContentLoaded', function() {
    const image = document.querySelector('#expandable-image-2');

    image.addEventListener('click', function() {
        if (window.innerWidth <= 430) { 
            this.classList.toggle('fullscreen');
        }
    });
});


//  we make sure that icons do not translate
   document.addEventListener('DOMContentLoaded', function() {
      const elements = document.querySelectorAll('.material-icons-outlined');

      elements.forEach(element => {
        element.classList.add('notranslate');
      });
    });

// set a custom date for reviews
   document.addEventListener('DOMContentLoaded', () => {
            const changeDate = (dateElement) => {
                const dateText = dateElement.textContent.trim();
                const [day, month, year] = dateText.split('.').map(Number);
                const originalDate = new Date(year, month - 1, day);
                const realDate = new Date();
                const daysDifference = Math.floor(Math.random() * 6); 
                realDate.setDate(realDate.getDate() - daysDifference);

                const newDay = String(realDate.getDate()).padStart(2, '0');
                const newMonth = String(realDate.getMonth() + 1).padStart(2, '0');
                const newYear = realDate.getFullYear();

                dateElement.textContent = `${newDay}.${newMonth}.${newYear}`;
            };

            const dateElements = document.querySelectorAll('[data-section-id="template--23031808950575__testimonials_custom_FKNRXL"] .date span');
            dateElements.forEach(changeDate);
        });


// transferring the wishlist icon to the mobile version
document.addEventListener("DOMContentLoaded", function() {
  if (window.innerWidth <= 767) {
    const wishlistEngine = document.querySelector(".wishlist-engine");
    const ryviuWidgetTotal = document.querySelector("ryviu-widget-total");

    if (wishlistEngine && ryviuWidgetTotal) {
      // ryviuWidgetTotal.after(wishlistEngine);
    }
  }
});

window.addEventListener("resize", function() {
  if (window.innerWidth <= 767) {
    const wishlistEngine = document.querySelector(".wishlist-engine");
    const ryviuWidgetTotal = document.querySelector("ryviu-widget-total");

    if (wishlistEngine && ryviuWidgetTotal) {
      // ryviuWidgetTotal.after(wishlistEngine);
    }
  }
});

// Dynamically change the text on faq buttons
document.addEventListener('DOMContentLoaded', function() {
    function updateButtonText() {
      let language = document.documentElement.lang || 'en'; 

      let showAllButton = document.querySelector('.show-all-button');
      let collapseAllButton = document.querySelector('.collapse-all-button');

      if (showAllButton) {
        if (language === 'de') {
          showAllButton.textContent = 'Alle zeigen';
        } else if (language === 'en') {
          showAllButton.textContent = 'Show All';
        } 
      }

      if (collapseAllButton) {
        if (language === 'de') {
          collapseAllButton.textContent = 'Minimieren Alle';
        } else if (language === 'en') {
          collapseAllButton.textContent = 'Minimize All';
        } 
      }
    }

    updateButtonText();

    const observer = new MutationObserver(() => {
      updateButtonText();
    });

    observer.observe(document.documentElement, {
      attributes: true,
      attributeFilter: ['lang']
    });
  });

// Find the policy container and change it
document.addEventListener('DOMContentLoaded', function() {
    let elements = document.querySelectorAll('.shopify-policy__container');
    elements.forEach(function(element) {
        element.classList.remove('shopify-policy__container');
        element.classList.add('container-fluid');
    });
});
